module.exports = __webpack_public_path__ + "media/content-creator/health-1-71a93fd5.png";